import classNames from "classnames";
import React from "react";
import { RadioGroupContextProvider } from "./context";
import styles from "./index.module.css";
import { RadioGroupProps } from "./interface";
import InternalRadio from "./radio";

const RadioGroup: React.FC<RadioGroupProps> = (props) => {
  const {
    id,
    direction = "horizontal",
    options,
    value,
    onChange,
    children,
    disabled,
    className,
  } = props;

  const onRadioChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const lastValue = value;
    const val = ev.target.value;
    if (onChange && val !== lastValue) {
      onChange(ev);
    }
  };

  const renderGroup = () => {
    let childrenToRender = children;

    if (options && options.length > 0) {
      childrenToRender = options.map((option) => {
        if (typeof option === "string") {
          return (
            <InternalRadio
              key={option}
              disabled={disabled}
              value={option}
              checked={value === option}
              label={option}
            />
          );
        }
        return (
          <InternalRadio
            key={`radio-group-value-options-${option.value}`}
            disabled={option.disabled || disabled}
            value={option.value}
            checked={value === option.value}
            label={option.label}
          />
        );
      });
    }

    return (
      <div
        id={id}
        className={classNames(styles.radioGroup, className, {
          "flex-row gap-4": direction === "horizontal",
          "flex-col gap-2": direction === "vertical",
        })}
      >
        {childrenToRender}
      </div>
    );
  };

  return (
    <RadioGroupContextProvider
      value={{
        value,
        onChange: onRadioChange,
        disabled: props.disabled,
      }}
    >
      {renderGroup()}
    </RadioGroupContextProvider>
  );
};

export default React.memo(RadioGroup);
